<div class="main-content">
  @if (locationMessage != '') {
  <div>
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="alert alert-danger">
          <p>
            {{ locationMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
  } @if (locationMessage == '') {
  <div class="site-list">
    <div fxLayout="row" class="select-site-message">
      <div fxLayout="column">
        <span class="font-size-h1 color-city-blue">{{
          "sitesignin_lbl_select_site" | translate
        }}</span>
        <span class="font-size-body-text color-dark-blue">{{
          "sitesignin_lbl_please_select" | translate
        }}</span>
      </div>
    </div>
    <div class="divider"></div>
    @if (!(sites) || sites.length <= 0) {
    <div fxLayout="row">
      <span class="display-grey color-city-neutral">
        {{ "sitesignin_lbl_not_available_range" | translate }}
      </span>
    </div>
    } @if (isDebugModeActive) {
    <div>
      <mat-expansion-panel class="my-no-padding-panel">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
          class="expansion-header"
        >
          <mat-panel-title class="name" fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100">
              <div fxLayout="column" fxLayoutAlign="space-between">
                <div class="color-dark-blue">
                  {{ "common_lbl_openmapview" | translate }}
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div fxLayout="column" fxFlex="100%">
          <div #mapContainer id="map" class="map"></div>
        </div>
      </mat-expansion-panel>
      <div class="divider"></div>
    </div>
    } @if (sites && sites.length > 0) {
    <div fxLayout="row" class="sites-list-container">
      <div fxLayout="column" fxFlex="100%">
        @for (site of sites; track site) {
        <div>
          <div fxLayout="row">
            <button
              mat-raised-button
              [class]="
                isSiteOnClickEnable(site) || !isSiteListJobCountEnable
                  ? 'bg-white'
                  : 'bg-grey'
              "
              (click)="siteSelectionOnclick(site)"
              id="btn_siteselection_{{ site.id }}"
              [disabled]="
                !isSiteOnClickEnable(site) && isSiteListJobCountEnable
              "
            >
              <div fxLayout="column" fxFlex="30%">
                <div fxFlex="0 100 100%" fxLayoutAlign="center center">
                  <img class="site-image" [src]="site.brand.imageUrl" />
                </div>
              </div>
              <div fxLayout="column" fxFlex="70%">
                <div fxLayout="row">
                  <span class="display-name color-city-blue">{{
                    site.name
                  }}</span>
                </div>
                @if (isSiteDistanceDisplayEnable) {
                <div fxLayout="row">
                  <span class="display-grey color-city-neutral">
                    <mat-icon class="display-grey-icon color-city-neutral"
                      >pin_drop</mat-icon
                    >
                    {{ calculateDistance(site.lat, site.lon) }}
                  </span>
                </div>
                } @if (isSiteListJobCountEnable && getJobCountForSite(site.id) >
                0) {
                <div fxLayout="row">
                  <span class="display-grey color-city-neutral"
                    >{{ getJobCountForSite(site.id) }}
                    {{ "sitesignin_lbl_jobavailabile" | translate }}</span
                  >
                </div>
                }
              </div>
            </button>
          </div>
          <div class="divider"></div>
        </div>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
